"use client";

import { DividerRow, ScrollReveal } from "../shared";
import type { DividerRowItem } from "../shared";
import { RadarIcon, HandHeartIcon, ShieldCheckIcon } from "../shared/icons";

type Signal = {
  label: string;
  href: string;
  icon: typeof RadarIcon;
  accent: string;
};

// Real existing routes - no new pages invented.
const SIGNALS: Signal[] = [
  { label: "Live Threat Signals", href: "/transactions/live", icon: RadarIcon, accent: "#22D3EE" },
  { label: "Verified Giving", href: "/charities", icon: HandHeartIcon, accent: "#A855F7" },
  { label: "Wallet Risk Insights", href: "/wallet-analysis", icon: ShieldCheckIcon, accent: "#3B82F6" },
];

const SIGNAL_ITEMS: DividerRowItem[] = SIGNALS.map((s) => {
  const Icon = s.icon;
  return {
    key: s.label,
    href: s.href,
    content: (
      <>
        <Icon size={17} className="shrink-0" style={{ color: s.accent }} />
        <span
          className="min-w-0 text-sm font-semibold leading-tight transition-colors group-hover:text-white"
          style={{ color: "#f1f5f9" }}
        >
          {s.label}
        </span>
      </>
    ),
  };
});

/**
 * Trust Signals strip: one unified bordered glass row split into three
 * equal columns by vertical divider lines (matches the client reference
 * exactly - not three separate floating chips).
 */
export default function TrustSignalsRow() {
  return (
    <section aria-label="Trust signals" className="page-section relative w-full py-4 sm:py-6">
      <ScrollReveal className="mx-auto max-w-6xl">
        <DividerRow
          items={SIGNAL_ITEMS}
          cellClassName="flex flex-1 items-center justify-center min-w-0 gap-2.5 px-4 py-3.5"
        />
      </ScrollReveal>
    </section>
  );
}
